const apigeeUrl = process.env.GATSBY_APIGEE_URL;
const astronUrl = `${process.env.GATSBY_ASTRON_API_URL}`;
const pdpaastronUrl = `${process.env.GATSBY_PDPA_CUST_API_URL}`;
const udfSiteUrl = `${process.env.GATSBY_UDF_SIT_URL}`;

const astronAdminUrl = `${astronUrl}/admin`;
const astronOrderUrl = `${astronUrl}/order`;
const astronInventoryUrl = `${astronUrl}/inventory`;
const astronCustServiceUrl = `${astronUrl}/customer-services`;
const astronShoppingUrl = `${astronUrl}/shoppingcart`;
const astronDeviceUrl = `${astronUrl}/device`;
const astronPriceplanPromoUrl = `${astronUrl}/priceplan-promo`;
const astronAddonUrl = `${astronUrl}/addon`;
const astronDeliveryUrl = `${astronUrl}/delivery`;
const astronPaymentUrl = `${astronUrl}/payment`;
const astronpdpaUrl = `${pdpaastronUrl}/admin`;

export const authApi = {
  REQUEST_TOKEN: `${apigeeUrl}/oauth/token`,
  MFA_REGISTER_DEVICE: `${apigeeUrl}/auth/mfa/devices`,
  MFA_REQUEST_OTP: `${apigeeUrl}/auth/mfa/challenge/email/otp`,
  MFA_VERIFY_OTP: `${apigeeUrl}/auth/mfa/auth/email/otp`,
  GET_AUTHENTICATE: `${astronAdminUrl}/authenticate`,
  PDPA_AUTHENTICATE: `${astronAdminUrl}/pdpa/authenticate`,
  PDPA_REFRESHTOKEN: `${astronAdminUrl}/pdpa/refreshToken`,
  CUSTOMER_VALIDATE: `${astronAdminUrl}/customerValidate`,
  CHECK_BLACKLIST: `${astronAdminUrl}/checkBlacklist`,
  GET_CONFIG_BY_BRN: `${astronAdminUrl}/getConfiguredMstKeyValuesByBrn`,
  GET_OTHER_CONFIGS: `${astronAdminUrl}/appconfig/getglobalconfigmstkeyvalues/GLOBAL_CONFIG`,
  PDPA_VALIDATE: `${astronpdpaUrl}/pdpa/valLink`,
  MYEMPOWER_USER_PERMISSION: `${udfSiteUrl}api/myempadmin/myemp/otherapp/permissions/gleeshop`,
  STAFF_USER_PERMISSION: `${udfSiteUrl}api/myempadmin/myemp/otherapp/permissions/gleeshop/staffplan`,
  EMPOWER_USER_PERMISSION: `${astronAdminUrl}/user/permissions`,
  EMPOWER_USER_DETAILS: `${udfSiteUrl}api/udfadmin/login/users/me`,
  EMPOWER_REFRESH_TOKEN_URL: `${udfSiteUrl}api/udfadmin/auth-udf/refreshtoken`,
  APPROVE_VALIDATE: `${astronpdpaUrl}/approve/valLink`,
};

export const profileApi = {
  FETCHACCOUNT: `${astronAdminUrl}/fetchAccount`,

  PROFILE_GETPROFILE: `${astronAdminUrl}/profile/getProfile`,
  PROFILE_GETPROFILEWITHOUTDOC: `${astronAdminUrl}/profile/getProfileWithoutDoc`,
  PROFILE_UPDATEPROFILE: `${astronAdminUrl}/profile/updateProfile`,
  PROFILE_GETUSERPROFILE: `${astronAdminUrl}/profile/getuserprofiles`,

  DOCUMENT_UPLOAD_DOCUMENT: `${astronAdminUrl}/document/uploadDocument`,
  DOCUMENT_DELETE_DOCUMENT: `${astronAdminUrl}/document/deleteDocument`,
  //DOCUMENT_DOWNLOAD_DOCUMENT: `${astronAdminUrl}/document/downloadDocument`,
  DOCUMENT_DOWNLOAD_DOCUMENT: `${astronAdminUrl}/document/downloadfilemultipart`,

  GET_POLICY_TEMPLATE: `${astronAdminUrl}/getPolicyTemplate`,
  GET_POLICY_LIST: `${astronAdminUrl}/fetchPolicies`,
  GET_POLICY_DETAILS: `${astronAdminUrl}/fetchPolicyDetails`,
  UPDATE_POLICY: `${astronAdminUrl}/updatePolicy`,
  DELETE_POLICY: `${astronAdminUrl}/deletePolicy`,
  APPCONGIG_GET_TAB_CONFIG_TYPE: `${astronAdminUrl}/appconfig/getByConfigType/ORDER_PAGE_STATUS`,
  CHANGE_BILLING_ADDRESS: `${astronOrderUrl}/changebillingaddress`,
  DOCUMENT_UPLOAD_DOCUMENT_MULTIPART: `${astronAdminUrl}/document/uploaddocumentmultipart`,
  DOCUMENT_DOWNLOAD_DOCUMENT_MULTIPART: `${astronAdminUrl}/document/downloadfilemultipart`
};

export const adminApi = {
  GET_ELIGIBLE_LINE_COUNT: `${astronAdminUrl}/getEligibleLineCount`,
  GET_NO_DEVICE_CONFIGS: `${astronAdminUrl}/appconfig/getglobalconfigmstkeyvalues/NO_DEVICE`,
};

export const orderApi = {
  GET_ALL_ORDER_HISTORY: `${astronOrderUrl}/getAllOrderTranHistory`,
  POST_ORDER: `${astronOrderUrl}/order`,
  POST_ORDER_SUBMISSION: `${astronOrderUrl}/order/submission`,
  GET_ORDER_BY_MERCHANT: `${astronOrderUrl}/getOrderByMerchantRef`,
  GET_TRANSACTION_HISTORY_DETAIL: `${astronOrderUrl}/transhist/order`,
  GET_PDPA_ORDER_DETAILS: `${astronOrderUrl}/pdpa/valLink`,
  GET_ORDERINFO_PDPA: `${astronOrderUrl}/getOrderReport`,
  UPDATE_WAIVER_REQUEST_STATUS: `${astronOrderUrl}/waiverrequest/status/update`,
  GET_WAIVERED_ORDER: `${astronOrderUrl}/decrypt/orderid`,
  UPLOAD_MULTILINE_RECP_ESIM: `${astronOrderUrl}/upload`,
  UPLOAD_MULTILINE_RETRIGGER_ESIM: `${astronOrderUrl}/retry/esim/multirecp`,
  DOWNLOAD_MULTILINE_RECP_ESIM: `${astronOrderUrl}/esim/downloadtpl`,
  PDPA_ESIM_QR_RETRIEVAL: `${astronOrderUrl}/esim/valEsimQrLink`,
  // DOWNLOAD_MULTILINE_RETRIGGER_ESIM :`${astronOrderUrl}/retry/esim/multirecp`,
  GET_BULK_ORDER_DETAILS_BY_ITEM_ID: `${astronOrderUrl}/bulkorder/getorderbyitemid` //Needs to be checked and corrected
};

export const inventoryApi = {
  GET_SERVICE_NUMBERS: `${astronInventoryUrl}/servicenos`,
  PUT_RESERVE_SERVICE_NOS: `${astronInventoryUrl}/reserveservicenos`,
  PUT_UNRESERVE_SERVICE_NOS: `${astronInventoryUrl}/unreserveservicenos`,
  GET_RESERVE_SERVICE_NOS_BRN_RESBY: `${astronInventoryUrl}/getReservedSvcByBrnAndResBy`,
  GET_ALL_UNRESERVE_SERVICE_NOS: `${astronInventoryUrl}/getAllUnReservedSvcNo`,
  DIST_CARD_PROFILE: `${astronInventoryUrl}/distCardProfile`,
  GET_SIM_CHARGE: `${astronAddonUrl}/getsimcharge`,
  ESIM_CARD_PROFILE_TYPE: `${astronInventoryUrl}/sim/cardprofiletype`,
};

export const stafPlanApi = {
  GET_STAFF_PLAN_ELIGIBILITY: `${astronAdminUrl}/users/internal/`,
  STAFF_PLAN_RECON_ELIGIBILITY: `${astronCustServiceUrl}/staff/reconeligibility`,
};

export const custServiceApi = {
  FETCH_EXISTING_VASES: `${astronCustServiceUrl}/fetchExistingVases`,
  GET_RECONTRACT_ELIGIBILITY_VALUES: `${astronCustServiceUrl}/getRecontractEligibilityValues`,
  GET_PRODUCT_PRICEPLAN: `${astronCustServiceUrl}/product/plan`,
  GET_CONTRACT_SERVICE_NUMBERS: `${astronCustServiceUrl}/retrieveCustomerServiceNumbers`,
  GET_CONTRACT_SERVICE_NUMBERS_FOR_TERMINATE_NUMBERS: `${astronCustServiceUrl}/retrievecustomersvcnosforterminateline`,
  GET_CONTRACT_SERVICE_NUMBERS_FOR_CHANGE_PLAN: `${astronCustServiceUrl}/retrievecustomersvcnosforchangeplan`,
  GET_SERVICE_NUMBERS_BY_BRN: `${astronCustServiceUrl}/svcByCustomerBrn`,
  GET_SERVICE_NUMBER_ELIGIBILITY_DETAILS: `${astronCustServiceUrl}/svc/checkEligibility`,
  CHANGE_USER_UPDATE: `${astronCustServiceUrl}/updateprofile`,
  CHANGE_USER__ALLDETAILS: `${astronCustServiceUrl}/profile/getuserprofiles`,
  FETCH_ALL_PRODUCTS: `${astronCustServiceUrl}/fetchallproducts`,
  BILLING_ADDRESS_SERVICENO: `${astronCustServiceUrl}/oft/getacctinfobysvcno`,
  CHECK_FOR_PARENT_SERVICE_NUMBER: `${astronCustServiceUrl}/childline/details`,
  GET_SVC_NOS_REPLACE_SIM: `${astronCustServiceUrl}/retrievecustomersvcnosforreplacesim`,
  GET_ADDONS_EXISTING_VAS_VALUES: `${astronCustServiceUrl}/svc/customereaddondetailsforbrn`,
  GET_SIM_BY_ACTIVATION: `${astronCustServiceUrl}/activate/sim`,
  GET_SVC_NOS_CEASE_ADDONS: `${astronCustServiceUrl}/svc/customerserviceaddondetails`,
  GET_SVC_NOS_DETAILS_CEASE_ADDONS: `${astronCustServiceUrl}/svc/customereaddontypedetails`
};

export const shoppingApi = {
  REQUEST_SAVE_TO_CART: `${astronShoppingUrl}/shoppingCart`,
  GET_CART_DETAIL: `${astronShoppingUrl}/shoppingCart`,
  SHOPPINGCARTS_LIST: `${astronShoppingUrl}/shoppingCarts`,
  SHOPPINGCARTS_DEACTIVATE: `${astronShoppingUrl}/shoppingCarts/deactivate`
};

export const catalogueApi = {
  GET_DEVICE_BRAND: `${astronDeviceUrl}/deviceBrands`,
  GET_DEVICE_BY_PLANGROUP: `${astronDeviceUrl}/catalogue/deviceByPlanGroup`,
  GET_PRICEPLAN_GROUP: `${astronPriceplanPromoUrl}/pricePlanGrouped`,
  GET_MOBILE_SHARE_PARENT_LINES: `${astronCustServiceUrl}/svc/listbybrn`,
  GET_MOBILE_SHARE_ELIGIBILITY: `${astronCustServiceUrl}/svc/mobileshareeligibility`,
  GET_PRICEPLAN_ASSOCIATIONS: `${astronDeviceUrl}/allCatalogAssociations`,
  GET_ADDONS_GROUP: `${astronAddonUrl}/addongroups/`,
  GET_EQUIPMENT_VARIANT: `${astronDeviceUrl}/device/variant`,
  VALIDATE_EQUIPMENT_DEP_ADDON: `${astronDeviceUrl}/device/depAddon`,
  GET_MOBILE_SHARE_PLANS: `${astronPriceplanPromoUrl}/planbytype`,
  GET_CHECK_RESERVE: `${astronDeviceUrl}/stockmgmt/checkreserve`,
  GET_RESERVED_STOCKS: `${astronDeviceUrl}/stockmgmt/variant`,
  GET_SMART_TEMPLATE_DETAILS: `${astronAdminUrl}/smarttemplate/gettemplates`,
  UPDATE_SMART_TEMPLATE_NAME: `${astronAdminUrl}/smarttemplate/updatetemplatename`,
  DELETE_SMART_TEMPLATE: `${astronAdminUrl}/smarttemplate/deletetemplatebyid`,
  GET_SMART_TEMPLATE_BY_ID: `${astronAdminUrl}/smarttemplate/gettemplatebyid`,
  GET_CART_FROM_TEMPLATE: `${astronAdminUrl}/smarttemplate/getcartfromtemplate`,
  SAVE_SMART_TEMPLATE: `${astronAdminUrl}/smarttemplate/savetemplate`,
  ADDON_BY_PRICEPLAN:`${astronAddonUrl}/addonbundledForMSAPPList`,
  DEP_RESELLER_BRN_ID:`${astronAdminUrl}/ddconfig/DEP_RESELLER_BRN`
};

export const deliveryApi = {
  GET_DELIVERY_SLOTS: `${astronDeliveryUrl}/delivery/slots`,
  GET_ADDRESS_POSTALCODE: `${astronDeliveryUrl}/getaddress`,
  GET_DELIVERY_ADDRESS_LIST_BY_BRN: `${astronDeliveryUrl}/delivery/address/brn`,
  UPDATE_DELIVERY_ADDRESS: `${astronDeliveryUrl}/delivery/address`,
  DELETE_DELIVERY_ADDRESS: `${astronDeliveryUrl}/delivery/address/deactivate`,
  GET_POPSTATION_LIST: `${astronDeliveryUrl}/delivery/popstations`,
  GET_POPSTATION_ADDRESS: `${astronDeliveryUrl}/delivery/popstation/geocode`,
  GET_CUSTOMER_IDS_BY_BRN: `${astronDeliveryUrl}/delivery/customerIdsByBrn`,

  GET_ALL_DELIVERY_CHARGES: `${astronDeviceUrl}/getAllTypesOfDeliveryCharges`,
  GET_SPLIT_PAYMENT_TYPE: `${astronAdminUrl}/splitpayment`,

  PDPA_RETRIEVE_RES_ADDRESS: `${astronDeliveryUrl}/custaddr/rethomeaddr`,
  PDPA_SAVE_NEW_RES_ADDRESS: `${astronDeliveryUrl}/custaddr/homeaddr`,
  PDPA_UPDATE_EXIST_ADDRESS: `${astronDeliveryUrl}/custaddr/homeaddr`,
  PDPA_DELETE_EXIST_ADDRESS: `${astronDeliveryUrl}/custaddr/deletehomeaddr`
};

export const paymentApi = {
  FETCH_PAYMENTTYPE_AND_BALANCE: `${astronPaymentUrl}/fetchPaymentTypesAndBalances`,
  FETCH_BILLING_ADDRESS_LIST_BY_BRN: `${astronPaymentUrl}/payment/billing/address/brn`,
  FETCH_BILLING_ACCOUNTS_LIST_BY_BRN: `${astronPaymentUrl}/billingaddress/brnwithenroll`,
  FETCH_ENROLLMENT_STATUS: `${astronPaymentUrl}/mrc/enrollstatus`,
  FETCH_CREDIT_CARD_DETAIL: `${astronPaymentUrl}/mrc/enrollcreditcard`,
  FETCH_BILLING_SERVICE_NUMBERS: `${astronCustServiceUrl}/retrievecustomersvcnosbybillingaccno`
};

export const numberShareApi = {
  NUMBER_SHARE: `${astronAddonUrl}/vasbytype/NUMBER_SHARE_PRD_VAS_TYPE`,
  SERVICE_NUMBER_SHARE: `${astronCustServiceUrl}/svc/listbybrn`,
  NUMBER_SHARE_ELIGIBILITY: `${astronCustServiceUrl}/svc/numbershareeligibility`
};

export const changeNumberApi = {
  DIST_CARD_PROFILE_CHANGE_NUMBER: `${astronCustServiceUrl}/getsimtypefromserviceno`,
  NEW_SERVICE_NUMBER_CHANGE: `${astronInventoryUrl}/servicenoschangenumber`,
  EXISTING_SERVICE_NUMBER_CHANGE: `${astronCustServiceUrl}/retrievecustomersvcnosforchangenumber`
};

export const serRoadshowApi = {
  GET_DEVICE_LIST_FOR_SER_FLOW: `${astronDeviceUrl}/user/getserroadshowdetails`,
  CHECK_STOCK_AVAILABILITY: `${astronDeviceUrl}/getdevicestock`
};

export const promoConfigsApi = {
  IS_PROMO_CONFIGURED: `${astronAdminUrl}/promoconfig/getpromoconfigcheck`
};

export const numberPortApi = {
  NUMBER_PORT_ELIGIBILITY: `${astronCustServiceUrl}/numberporteligibility`,
  SERVICE_NUMBER_SHARE: `${astronCustServiceUrl}/svc/listbybrn`,
  NUMBER_SHARE_ELIGIBILITY: `${astronCustServiceUrl}/svc/numbershareeligibility`,
  DOCUMENT_UPLOAD_NUMBER_PORT_DOCUMENT: `${astronCustServiceUrl}/upload/document`,
  PORT_IN_DATE_LIST: `${astronCustServiceUrl}/portindates`,
  DOCUMENT_DOWNLOAD_DOCUMENT: `${astronCustServiceUrl}/document/downloadDocument`,
  DOCUMENT_DELETE_DOCUMENT: `${astronCustServiceUrl}/delete/tl/doc`
}

export const transferLineApi = {
  GET_TRANSFER_OPTION: `${astronCustServiceUrl}/gettransfermobilelinetypes`,
  GET_FORM_FIELDS_FOR_APPLICATION: `${astronCustServiceUrl}/transferline/formdetailsbytype`,
  GET_TRANSFER_LINE_UPLOAD_DOCUMENT: `${astronCustServiceUrl}/upload/tl/document`,
  GET_TRANSFER_LINE_DOWNLOAD_DOCUMENT: `${astronCustServiceUrl}/download/tl/doc`,
  GET_TRANSFER_LINE_DELETE_DOCUMENT: `${astronCustServiceUrl}/delete/tl/doc`,
  SUBMIT_ORDER_REQUEST_TRANSFER_LINE: `${astronOrderUrl}/transfermobileline/submitrequest`,
  GET_FINAL_SUBMIT_ORDER_REQUEST: `${astronCustServiceUrl}/transferline/submitrequest`,
  GET_TRANSFER_MOBILE_LINE_PERSONAL_PLANS: `${astronAdminUrl}/appconfig/getglobaldepconfigmstkeyvalues/TRANSFER_MOBILE_LINE_PERSONAL_PLANS`
};

export const simactivationApi = {
  TRIGGER_ESIM_ACTIVATION_EMAIL: `${astronOrderUrl}/retry/esimemail`,
  UPLOAD_RETRIGGER_ESIM_ACTIVATION: `${astronOrderUrl}/retry/esim/multirecp`,
  SIM_ACTIVATION_STATUS_REQUEST : `${astronOrderUrl}/simactivation/status`,
  SIM_ACTIVATION_SUBMIT_REQUEST: `${astronOrderUrl}/simactivation/submit`,
};

export const suspendUnsuspendApi = {
  SUSPEND_CUSTOMER_SERVICE_NUMBERS: `${astronCustServiceUrl}/retrievecustomersvcnosforsuspendandunsuspendline`,
  SUSPEND_CUSTOMER_SERVICE_NUMBERS_ELIGIBILITY: `${astronCustServiceUrl}/svc/suspensioneligibility`
};

export const refitLineApi = {
  REFIT_SERVICE_NUMBER: `${astronCustServiceUrl}/getrefitlinedetails`,
  REFIT_ORDER_SUBMISSION: `${astronOrderUrl}/order/submission`
};

export const approvalFlowApi = {
  GET_TRANSFER_LINE_ORDER: `${astronCustServiceUrl}/decrypt/requestid`,
  GET_TRANSFER_LINE_DOC_BY_ID: `${astronCustServiceUrl}/tl/getdocsbyid`,
  GET_UNMASKING_APPROVAL: `${astronCustServiceUrl}/decrypt/requestid`,
  UPDATE_UNMASKING_STATUS: `${astronCustServiceUrl}/unmaskrequest/status/update`
}

export const eFormApi = {
  EFORM_GENERATION_STATUS: `${astronAdminUrl}/eform/genstatus`,
  DOWNLOAD_EFORM: `${astronAdminUrl}/eform/downloadbrneform`
};

export const numberPoolApi = {
  NUMBER_POOL_BILLING_ACCOUNTS: `${astronCustServiceUrl}/pooling/eligible/billingacc`,
  NUMBER_POOL_CHECKOUT_BILLING_ACCOUNTS: `${astronPaymentUrl}/payment/billing/address/billingaccno`
};